module.exports = __webpack_public_path__ + "static/media/SIJNoon.d75f3152.png";